import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import { ErrorOutline, Refresh, ArrowForward } from '@mui/icons-material';
import { MAIL_COLORS } from '../constants';

interface MailAuthErrorProps {
  message?: string;
  onRetry: () => void;
  onNavigateToProfile: () => void;
}

export const MailAuthError: React.FC<MailAuthErrorProps> = ({
  message,
  onRetry,
  onNavigateToProfile
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '65vh',
        p: 3
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 520,
          width: '100%',
          p: { xs: 3.5, sm: 5 },
          borderRadius: '24px',
          border: '1px solid #fed7aa',
          bgcolor: '#ffffff',
          boxShadow: '0 10px 30px rgba(234, 88, 12, 0.08)',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2.5
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: '20px',
            bgcolor: '#fff7ed',
            border: '1px solid #fed7aa',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ea580c',
            mb: 0.5
          }}
        >
          <ErrorOutline sx={{ fontSize: 38 }} />
        </Box>

        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: '#9a3412',
              letterSpacing: '-0.02em',
              mb: 1
            }}
          >
            Ошибка авторизации в почте
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: '#475569',
              lineHeight: 1.6,
              fontSize: '0.95rem'
            }}
          >
            {message || 'Не удалось выполнить вход на почтовый сервер Carbonio. Возможно, пароль был изменен или указан неверно.'}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center', pt: 1 }}>
          <Button
            variant="outlined"
            onClick={onRetry}
            startIcon={<Refresh />}
            sx={{
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 600,
              borderColor: '#cbd5e1',
              color: '#334155',
              px: 3,
              '&:hover': {
                borderColor: '#94a3b8',
                bgcolor: '#f1f5f9'
              }
            }}
          >
            Повторить
          </Button>

          <Button
            variant="contained"
            onClick={onNavigateToProfile}
            endIcon={<ArrowForward />}
            sx={{
              bgcolor: MAIL_COLORS.primary,
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              '&:hover': {
                bgcolor: MAIL_COLORS.primaryHover
              }
            }}
          >
            Обновить данные в профиле
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default MailAuthError;
